export const EVENT_HUBS_TITLE_TEXT = {
    id: 'oe.eventHubs.pageTitle',
    defaultMessage: '{prefix}Event Hubs',
    description: 'Title for the Event Hubs page'
};
export const EVENT_HUB_COLUMN_NAME_TEXT = {
    id: 'oe.eventHubs.column.name',
    defaultMessage: 'Name',
    description: 'Column name'
};

export const EVENT_HUB_COLUMN_CREATED_DATE_TEXT = {
    id: 'oe.eventHubs.column.createdDate',
    defaultMessage: 'Created Date',
    description: 'Column name'
};

export const NO_EVENT_HUBS_MESSAGE_TEXT = {
    id: 'oe.eventHubs.noEventHubsMessage',
    defaultMessage: 'There are no Event Hubs.',
    description: 'Message displayed when there are no Event Hubs'
};

export const NEW_HUB_TEXT = {
    id: 'oe.eventHubs.newHub',
    defaultMessage: '{prefix}New Hub',
    description: 'Button text to create a new Event Hub'
};

export const EDIT_HUB_TEXT = {
    id: 'oe.eventHubs.editHub',
    defaultMessage: 'Edit Hub',
    description: 'Button text to edit Event Hub'
};

export const DELETE_HUB_TEXT = {
    id: 'oe.eventHubs.deleteHub',
    defaultMessage: 'Delete Hub',
    description: 'Button text to edit Delete Hub'
};

export const DELETE_HUB_WITH_NAME_TEXT = {
    id: 'oe.eventHubs.deleteHubWithName',
    defaultMessage: 'delete {hubName}?',
    description: 'Confirmation message text when deleting an Event Hub'
};

export const DELETE_HUB_UNDONE_TEXT = {
    id: 'oe.eventHubs.deleteHubUndone',
    defaultMessage: 'This action cannot be undone.',
    description: 'Warning message text when deleting an Event Hub'
};

export const HUB_DELETED_NOTIFICATION_TEXT = {
    id: 'oe.eventHubs.hubDeletedNotification',
    defaultMessage: '{hubName} deleted successfully',
    description: 'Notification message text when an Event Hub is deleted successfully'
};

export const NAME_FIELD_LABEL = {
    id: 'oe.eventHubs.formField.name',
    defaultMessage: 'Name',
    description: 'Label for the Name field in the Event Hub form'
};

export const EVENT_HUB_URL_TEXT = {
    id: 'oe.eventHub.eventHubUrl',
    defaultMessage: 'Hub Subdomain',
    description: 'Label text',
};

export const NOT_SELECTED_HUB_URL_TEXT = {
    id: 'oe.eventHub.noSelectedHubURL',
    description: 'warning message text',
    defaultMessage: 'You have not selected a URL for the Hub yet.',
};

export const CONFIGURE_HUB_URL_TEXT = {
    id: 'oe.eventHubs.configure',
    defaultMessage: 'Configure Hub URL',
    description: 'Title for the Configure Hub URL popup',
};

export const HUB_ATTENDEES_COLUMN_NAME_TEXT = {
    id: 'oe.eventHubAttendees.column.name',
    defaultMessage: 'Name',
    description: 'Column name',
};

export const HUB_ATTENDEES_COLUMN_EMAIL_TEXT = {
    id: 'oe.eventHubAttendees.column.email',
    defaultMessage: 'Email',
    description: 'Column name',
};

export const HUB_ATTENDEES_COLUMN_ORGANIZATION_TEXT = {
    id: 'oe.eventHubAttendees.column.organization',
    defaultMessage: 'Organization',
    description: 'Column name',
};

export const HUB_ATTENDEES_COLUMN_ORGANIZATION_TYPE_TEXT = {
    id: 'oe.eventHubAttendees.column.organizationType',
    defaultMessage: 'Organization Type',
    description: 'Column name',
};

export const HUB_ATTENDEES_COLUMN_TITLE_TEXT = {
    id: 'oe.eventHubAttendees.column.title',
    defaultMessage: 'Title',
    description: 'Column name',
};

export const HUB_ATTENDEES_COLUMN_PHONE_NUMBER_TEXT = {
    id: 'oe.eventHubAttendees.column.phoneNumber',
    defaultMessage: 'Phone Number',
    description: 'Column name',
};

export const HUB_ATTENDEES_COLUMN_SALUTATION_TEXT = {
    id: 'oe.eventHubAttendees.column.salutation',
    defaultMessage: 'Salutation',
    description: 'Column name',
};

export const HUB_ATTENDEES_COLUMN_ASSISTANT_EMAIL_TEXT = {
    id: 'oe.eventHubAttendees.column.assistantEmail',
    defaultMessage: 'Assistant Email',
    description: 'Column name',
};

export const HUB_ATTENDEES_COLUMN_ACCESS_CODE_TEXT = {
    id: 'oe.eventHubAttendees.column.accessCode',
    defaultMessage: 'Access Code',
    description: 'Column name',
};

export const HUB_ATTENDEES_COLUMN_EXTERNAL_ATTENDEE_ID_TEXT = {
    id: 'oe.eventHubAttendees.column.externalAttendeeId',
    defaultMessage: 'External Attendee ID',
    description: 'Column name',
};

export const HUB_ATTENDEES_COLUMN_REGISTRATION_DATE_TEXT = {
    id: 'oe.eventHubAttendees.column.registrationDate',
    defaultMessage: 'Registration Date',
    description: 'Column name',
};

export const HUB_ATTENDEES_COLUMN_STATUS_TEXT = {
    id: 'oe.eventHubAttendees.column.status',
    defaultMessage: 'Registration Status',
    description: 'Column name',
};

export const NO_HUB_ATTENDEES_MESSAGE_TEXT = {
    id: 'oe.eventHubAttendees.noAttendeesMessage',
    defaultMessage: 'No attendees have been added to this Event Hub.',
    description: 'Message displayed when there are no Hub Attendees',
};

export const MANAGE_URL_TEXT = {
    id: 'oe.eventHubs.manageUrl',
    defaultMessage: 'Manage URL',
    description: 'Title for the Manage URL modal',
};

export const CREATE_URL_TEXT = {
    id: 'oe.eventHubs.createUrl',
    defaultMessage: 'Create URL',
    description: 'Button text to create a URL for the Event Hub'
};

export const NO_HUB_URL_CREATED_TEXT = {
    id: 'oe.eventHubs.noHubUrlCreated',
    defaultMessage: 'You haven\'t created a URL for your Hub yet',
    description: 'Message displayed when no URL has been created for the Event Hub'
};

export const NEW_ORGANIZATION_TEXT = {
    id: 'oe.eventHubs.newOrganization',
    defaultMessage: 'New Organization',
    description: 'Menu option text for creating a new Hub Organization'
};

export const NEW_ORGANIZATION_ADDED_NOTIFICATION_TEXT = {
    id: 'oe.eventHubs.newOrganizationAdded',
    defaultMessage: 'New Organization added',
    description: 'Success notification message when a new Hub Organization is created'
};

export const EDIT_HUB_ORGANIZATION_FORM_TITLE_TEXT = {
    id: 'oe.eventHubs.editOrganization',
    defaultMessage: 'Edit Organization',
    description: 'Title for the Hub Organization edit form popup'
};

export const EDIT_HUB_ORGANIZATION_UPDATED_NOTIFICATION_TEXT = {
    id: 'oe.eventHubs.organizationDetailsUpdated',
    defaultMessage: 'Organization details updated',
    description: 'Success notification message when a Hub Organization is updated'
};

export const HUB_ORGANIZATION_DELETION_STARTED_TEXT = {
    id: 'oe.eventHubs.organizationDeletionStarted',
    defaultMessage: 'Organization deletion has started',
    description: 'Notification shown when Hub Organization deletion starts'
};

export const HUB_ORGANIZATION_DELETION_SUCCESS_POPUP_TEXT = {
    id: 'oe.eventHubs.organizationDeletionCompleted',
    defaultMessage: 'Organization deletion has completed successfully',
    description: 'Alert shown when Hub Organization deletion completes'
};

export const HUB_ORGANIZATION_DELETION_FAILED_POPUP_TEXT = {
    id: 'oe.eventHubs.organizationDeletionFailed',
    defaultMessage: 'Organization deletion has failed',
    description: 'Alert shown when Hub Organization deletion fails'
};

export const DELETE_HUB_ORGANIZATION_SUCCESS_TOAST_TEXT = {
    id: 'oe.eventHubs.organizationDeleted',
    defaultMessage: '{organizationName} deleted successfully',
    description: 'Success toast shown when a Hub Organization is deleted'
};

export const NEW_HUB_ATTENDEE_TEXT = {
    id: 'oe.eventHubAttendees.newAttendee',
    defaultMessage: '{prefix}New Attendee',
    description: 'Button text to create a new Hub Attendee'
};

export const NEW_HUB_ATTENDEE_ADDED_NOTIFICATION_TEXT = {
    id: 'oe.eventHubAttendees.newAttendeeAdded',
    defaultMessage: 'New Attendee added',
    description: 'Success notification message when a new Hub Attendee is created'
};

export const HUB_ATTENDEE_FORM_TITLE_TEXT = {
    id: 'oe.eventHubAttendees.formTitle',
    defaultMessage: 'New Attendee',
    description: 'Title for the Hub Attendee creation form popup'
};

export const EDIT_HUB_ATTENDEE_FORM_TITLE_TEXT = {
    id: 'oe.eventHubAttendees.editFormTitle',
    defaultMessage: 'Edit Attendee',
    description: 'Title for the Hub Attendee edit form popup'
};

export const EDIT_HUB_ATTENDEE_UPDATED_NOTIFICATION_TEXT = {
    id: 'oe.eventHubAttendees.attendeeUpdated',
    defaultMessage: 'Attendee details updated',
    description: 'Success notification message when a Hub Attendee is updated'
};

export const DELETE_HUB_ATTENDEE_SUCCESS_TOAST_TEXT = {
    id: 'oe.eventHubAttendees.attendeeDeleted',
    defaultMessage: '{firstName} {lastName} deleted successfully',
    description: 'Success notification when a Hub Attendee is deleted'
};

export const OPEN_BUILDER_BUTTON_TEXT = {
    id: 'oe.eventHubs.openBuilder',
    defaultMessage: 'Open Builder',
    description: 'Button text to open the Hub Website Builder'
};

export const WEBSITE_BUILDER_BACK_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.back',
    defaultMessage: 'Back',
    description: 'Back button label in the Website Builder header'
};

export const WEBSITE_BUILDER_EDIT_PAGE_TAB_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.editPageTab',
    defaultMessage: 'Edit Page',
    description: 'Edit Page tab label in the Website Builder sidebar'
};

export const WEBSITE_BUILDER_EDIT_HUB_TAB_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.editHubTab',
    defaultMessage: 'Edit Hub',
    description: 'Edit Hub tab label in the Website Builder sidebar'
};

export const WEBSITE_BUILDER_EDITOR_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.editor',
    defaultMessage: 'Editor',
    description: 'Label shown on the minimized Website Builder sidebar'
};

export const MANAGE_PAGE_SELECT_LABEL_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.managePageSelectLabel',
    defaultMessage: 'Page:',
    description: 'Label prefix shown before the page selector dropdown in the Manage Page tab'
};

export const SAVE_PAGE_BUTTON_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.savePageButton',
    defaultMessage: 'Save Page',
    description: 'Button text to save the current Hub page in the Website Builder'
};

export const SAVE_CHANGES_BUTTON_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.saveChangesButton',
    defaultMessage: 'Save Changes',
    description: 'Button text to save Hub settings changes in the Website Builder'
};

export const HUB_SETTINGS_SELECT_LABEL_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.hubSettingsSelectLabel',
    defaultMessage: 'Hub Settings:',
    description: 'Label prefix shown before the Hub Settings selector in the Edit Hub tab'
};

export const HUB_SETTINGS_BRANDING_OPTION_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.hubSettingsBrandingOption',
    defaultMessage: 'Branding',
    description: 'Branding option text in the Hub Settings dropdown'
};

export const HUB_SETTINGS_REGISTRATION_OPTION_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.hubSettingsRegistrationOption',
    defaultMessage: 'Registration',
    description: 'Registration option text in the Hub Settings dropdown'
};

export const HUB_REGISTRATION_TOGGLE_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.registrationToggle',
    defaultMessage: 'Registration is {suffix}',
    description: 'Toggle label for Hub registration enabled/disabled in Website Builder'
};

export const HUB_REGISTRATION_APPROVAL_TOGGLE_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.registrationApprovalToggle',
    defaultMessage: 'Registration Approval via API is {suffix}',
    description: 'Toggle label for Hub registration approval in Website Builder'
};

export const HUB_REGISTRATION_APPROVAL_INFO_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.registrationApprovalInfo',
    defaultMessage: 'When enabled, Registration Approval via API allows Event Hub to verify attendee eligibility by querying the client\'s system when an attendee is not found in OE Central. This API check determines event access based on the client\'s response. If the attendee already exists in Central, no API verification is performed.',
    description: 'Info text for Hub Registration Approval via API toggle'
};

export const HUB_ONE_STEP_REGISTRATION_TOGGLE_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.oneStepRegistrationToggle',
    defaultMessage: 'One-Step Registration and Sign In is {suffix}',
    description: 'Toggle label for Hub one-step registration and sign in enabled/disabled in Website Builder'
};

export const HUB_ONE_STEP_REGISTRATION_INFO_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.oneStepRegistrationToggle.info',
    defaultMessage: 'When one-step registration and sign in is enabled, a user who registers and is Approved '
        + 'will be signed in automatically. There is no email confirmation step, meaning that with this option '
        + 'enabled, authentication into the Hub is less secure.',
    description: 'Info tooltip text for Hub one-step registration and sign in toggle'
};

export const HUB_SETTINGS_FOOTER_OPTION_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.hubSettingsFooterOption',
    defaultMessage: 'Footer',
    description: 'Footer option text in the Hub Settings dropdown'
};

export const HUB_MENU_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.hubMenuText',
    defaultMessage: 'Menu (Signed In)',
    description: 'Text for the Hub Menu (Signed In)'
};

export const HUB_MENU_PAGE_ROW_LABEL_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.hubMenuPageRowLabel',
    defaultMessage: 'Page: {pageName}',
    description: 'Row label for a page menu item in the Hub Menu (Signed In) list'
};

export const HUB_MENU_LINK_ROW_LABEL_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.hubMenuLinkRowLabel',
    defaultMessage: 'Link: {label}',
    description: 'Row label for a link menu item in the Hub Menu (Signed In) list'
};

export const HUB_MENU_ADD_ITEM_BUTTON_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.hubMenuAddItemButton',
    defaultMessage: '+ Add Menu Item',
    description: 'Button text to add a new menu item in the Hub Menu (Signed In) settings section'
};

export const HUB_MENU_NEW_LINK_MODAL_TITLE_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.hubMenuNewLinkModalTitle',
    defaultMessage: 'New Menu Item: Link',
    description: 'Title for the modal used to add a new Link menu item'
};

export const HUB_MENU_EDIT_LINK_MODAL_TITLE_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.hubMenuEditLinkModalTitle',
    defaultMessage: 'Edit Menu Item: Link',
    description: 'Title for the modal used to edit an existing Link menu item'
};

export const HUB_MENU_LINK_ENABLED_TOGGLE_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.hubMenuLinkEnabledToggle',
    defaultMessage: 'Menu Item is enabled',
    description: 'Toggle label for whether a Link menu item is enabled'
};

export const HUB_MENU_LINK_LABEL_FIELD_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.hubMenuLinkLabelField',
    defaultMessage: 'Label',
    description: 'Label field for a Link menu item'
};

export const HUB_MENU_LINK_URL_FIELD_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.hubMenuLinkUrlField',
    defaultMessage: 'URL',
    description: 'URL field for a Link menu item'
};

export const HUB_MENU_NO_LINKS_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.hubMenuNoLinks',
    defaultMessage: 'No Menu Items added yet',
    description: 'Empty state text shown when the hub has no Menu Items'
};

export const HUB_MENU_LINK_DISABLED_BADGE_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.hubMenuLinkDisabledBadge',
    defaultMessage: 'Disabled',
    description: 'Badge shown next to a disabled Link menu item in the Hub Menu (Signed In) list'
};

export const HUB_MENU_LINK_TYPE_NAME_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.hubMenuLinkTypeName',
    defaultMessage: 'Link',
    description: 'Name of the Link menu item type'
};

export const HUB_MENU_LINK_TYPE_DESCRIPTION_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.hubMenuLinkTypeDescription',
    defaultMessage: 'A menu item that links to an external website',
    description: 'Description of the Link menu item type'
};

export const HUB_FOOTER_TEXT_LABEL_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.footerTextLabel',
    defaultMessage: 'Footer Text',
    description: 'Label for the Hub Footer text field'
};

export const HUB_FOOTER_POWERED_BY_TOGGLE_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.footerPoweredByToggle',
    defaultMessage: 'Powered by OpenExchange is {suffix}',
    description: 'Toggle label for the Hub Footer Powered by OpenExchange logo displayed/not displayed'
};

export const HUB_REGISTRATION_DISPLAY_NAME_LABEL_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.registrationDisplayNameLabel',
    defaultMessage: 'Display Name',
    description: 'Label for the Hub registration Display Name field'
};

export const HUB_REGISTRATION_DISPLAY_NAME_PLACEHOLDER_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.registrationDisplayNamePlaceholder',
    defaultMessage: 'Register',
    description: 'Placeholder for the Hub registration Display Name field'
};

export const HUB_REGISTRATION_INSTRUCTIONS_LABEL_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.registrationInstructionsLabel',
    defaultMessage: 'Registration Instructions',
    description: 'Label for the Hub registration Instructions field'
};

export const HUB_REGISTRATION_BUTTON_LABEL_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.registrationButtonLabel',
    defaultMessage: 'Register button label',
    description: 'Label for the Hub registration Register button label field'
};

export const HUB_REGISTRATION_SUBMITTED_MESSAGE_LABEL_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.registrationSubmittedMessageLabel',
    defaultMessage: 'Registration submitted message',
    description: 'Label for the Hub registration submitted message field'
};

export const HUB_SIGN_IN_DISPLAY_NAME_LABEL_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.signInDisplayNameLabel',
    defaultMessage: 'Display Name',
    description: 'Label for the Hub Sign In Display Name field'
};

export const HUB_SIGN_IN_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.signInText',
    defaultMessage: 'Sign In',
    description: 'Text for the Hub Sign In'
};

export const HUB_SIGN_IN_REQUEST_LINK_INSTRUCTIONS_LABEL_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.signInRequestLinkInstructionsLabel',
    defaultMessage: 'Request Link Instructions',
    description: 'Label for the Hub Sign In Request Link Instructions field'
};

export const HUB_SIGN_IN_REQUEST_LINK_BUTTON_LABEL_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.signInRequestLinkButtonLabel',
    defaultMessage: 'Request link button label',
    description: 'Label for the Hub Sign In request link button label field'
};

export const HUB_SIGN_IN_LINK_REQUESTED_MESSAGE_LABEL_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.signInLinkRequestedMessageLabel',
    defaultMessage: 'Sign in Link Requested message',
    description: 'Label for the Hub Sign In link requested message field'
};

export const HUB_ONE_STEP_SIGN_IN_TOGGLE_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.oneStepSignInToggle',
    defaultMessage: 'One-Step Sign In is {suffix}',
    description: 'Toggle label for Hub one-step sign in enabled/disabled in Website Builder'
};

export const HUB_ONE_STEP_SIGN_IN_INFO_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.oneStepSignInToggle.info',
    defaultMessage: 'When one-step sign in is enabled, a user who enters an email address of an Approved '
        + 'attendee will be signed in automatically. There is no email confirmation step, meaning that with '
        + 'this option enabled, authentication into the Hub is less secure.',
    description: 'Info tooltip text for Hub one-step sign in toggle'
};

export const HUB_REGISTRATION_FORM_SECTION_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.registrationFormSection',
    defaultMessage: 'Registration Form',
    description: 'Section header for the Hub registration form fields configuration'
};

export const HUB_REGISTRATION_FIELDS_NOT_DISPLAYED_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.registrationFieldsNotDisplayed',
    defaultMessage: 'Fields not displayed',
    description: 'Collapsible section header for hidden Hub registration fields'
};

export const HUB_REGISTRATION_FIELD_DISPLAYED_TOGGLE_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.registrationFieldDisplayedToggle',
    defaultMessage: 'Field is displayed',
    description: 'Toggle label for displaying a Hub registration field'
};

export const HUB_REGISTRATION_FIELD_REQUIRED_TOGGLE_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.registrationFieldRequiredToggle',
    defaultMessage: 'Field is required',
    description: 'Toggle label for requiring a Hub registration field'
};

export const HUB_REGISTRATION_EDIT_FIELD_MODAL_TITLE_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.registrationEditFieldModalTitle',
    defaultMessage: 'Edit Field: {fieldName}',
    description: 'Title of the modal for editing a Hub registration field'
};

export const HUB_CUSTOM_FIELD_TYPE_TEXT_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.customFieldTypeText',
    defaultMessage: 'Free Text',
    description: 'Option label for the Free Text custom field type'
};

export const HUB_CUSTOM_FIELD_TYPE_DROPDOWN_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.customFieldTypeDropdown',
    defaultMessage: 'Single Select Dropdown',
    description: 'Option label for the Single Select Dropdown custom field type'
};

export const HUB_CUSTOM_FIELD_TYPE_TEXTAREA_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.customFieldTypeTextarea',
    defaultMessage: 'Text Box',
    description: 'Option label for the Text Box custom field type'
};

export const HUB_CUSTOM_FIELD_TYPE_CHECKBOX_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.customFieldTypeCheckbox',
    defaultMessage: 'Check Box',
    description: 'Option label for the Check Box custom field type'
};

export const HUB_LOGO_IMAGE_INFO_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.logoImageInfo',
    defaultMessage: 'Logo image is displayed in the top left of the menu bar.',
    description: 'Info tooltip for the Hub logo image field on the Edit Hub tab'
};

export const HUB_BACKGROUND_IMAGE_INFO_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.backgroundImageInfo',
    defaultMessage: 'Background image is displayed as a full screen background on all Hub pages.',
    description: 'Info tooltip for the Hub background image field on the Edit Hub tab'
};

export const NEW_PAGE_PLACEHOLDER_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.newPagePlaceholder',
    defaultMessage: 'New Page',
    description: 'Option shown in the page selector dropdown when no pages exist (create mode)'
};

export const NEW_PAGE_BUTTON_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.newPageButton',
    defaultMessage: '+ New Page',
    description: 'Button text to create a new Hub page in the Website Builder'
};

export const CUSTOM_PAGE_NAME_LABEL_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.customPage.pageName',
    defaultMessage: 'Page Name',
    description: 'Label for the Page Name field in the Custom Page form'
};

export const CUSTOM_PAGE_DISPLAY_NAME_LABEL_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.customPage.displayName',
    defaultMessage: 'Display Name',
    description: 'Label for the Display Name field in the Custom Page form'
};

export const CUSTOM_PAGE_PATH_LABEL_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.customPage.pagePath',
    defaultMessage: 'Page Path',
    description: 'Label for the Page Path field in the Custom Page form'
};

export const CUSTOM_PAGE_DESCRIPTION_LABEL_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.customPage.description',
    defaultMessage: 'Description',
    description: 'Label for the Description field in the Custom Page form'
};

export const CUSTOM_PAGE_ENABLED_LABEL_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.customPage.enabled',
    defaultMessage: 'Page is {suffix}',
    description: 'Label for the Enabled toggle in the Custom Page form'
};

export const MODULES_SECTION_LABEL_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.sectionLabel',
    defaultMessage: 'Modules',
    description: 'Section label for the list of modules on a Hub page'
};

export const MODULES_INACTIVE_SECTION_LABEL_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.inactiveSectionLabel',
    defaultMessage: 'Deactivated Modules',
    description: 'Header for the collapsible section listing deactivated modules on a Hub page'
};

export const ADD_MODULE_BUTTON_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.addButton',
    defaultMessage: '+ Add Module',
    description: 'Button text to open the module type picker'
};

export const EVENTS_MODULE_TYPE_NAME_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.eventsTypeName',
    defaultMessage: 'Events',
    description: 'Name of the Events module type in the type picker'
};

export const EVENTS_MODULE_TYPE_DESCRIPTION_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.eventsTypeDescription',
    defaultMessage: 'Displays events matching a specific set of attributes',
    description: 'Description of the Events module type in the type picker'
};

export const SPEAKERS_MODULE_TYPE_NAME_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.speakersTypeName',
    defaultMessage: 'Speakers',
    description: 'Name of the Speakers module type in the type picker'
};

export const SPEAKERS_MODULE_TYPE_DESCRIPTION_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.speakersTypeDescription',
    defaultMessage: 'Profiles and bios of speakers',
    description: 'Description of the Speakers module type in the type picker'
};

export const NEW_EVENTS_MODULE_MODAL_TITLE_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.newEventsModalTitle',
    defaultMessage: 'New Module: Events',
    description: 'Title of the modal when creating a new Events module'
};

export const EDIT_EVENTS_MODULE_MODAL_TITLE_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.editEventsModalTitle',
    defaultMessage: 'Edit Module: Events',
    description: 'Title of the modal when editing an existing Events module'
};

export const MODULE_ACTIVE_LABEL_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.activeLabel',
    defaultMessage: 'Module is {suffix}',
    description: 'Label for the Module is enabled/disabled toggle'
};

export const MODULE_LABEL_FIELD_LABEL_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.labelFieldLabel',
    defaultMessage: 'Label',
    description: 'Label for the Label field of a module'
};

export const MODULE_LABEL_DISPLAYED_LABEL_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.labelDisplayedLabel',
    defaultMessage: 'Label is {suffix}',
    description: 'Label for the Label is displayed/hidden toggle'
};

export const MODULE_SPEAKERS_DISPLAYED_LABEL_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.speakersDisplayedLabel',
    defaultMessage: 'Speakers are {suffix}',
    description: 'Label for the Speakers are displayed/hidden toggle'
};

export const MODULE_UPCOMING_EVENTS_DISPLAYED_LABEL_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.upcomingEventsDisplayedLabel',
    defaultMessage: 'Upcoming events are {suffix}',
    description: 'Label for the Upcoming events are displayed/not displayed toggle'
};

export const MODULE_PAST_EVENTS_DISPLAYED_LABEL_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.pastEventDisplayedLabel',
    defaultMessage: 'Past events are {suffix}',
    description: 'Label for the Past events are displayed/not displayed toggle'
};

export const MODULE_UPCOMING_EVENTS_DAYS_PREFIX_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.upcomingEventDaysPrefix',
    defaultMessage: 'Include events from the next',
    description: 'Prefix text before the upcoming events days input'
};

export const MODULE_PAST_EVENTS_DAYS_PREFIX_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.pastEventDaysPrefix',
    defaultMessage: 'Include events from the past',
    description: 'Prefix text before the past events days input'
};

export const MODULE_EVENTS_DAYS_SUFFIX_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.eventsDaysSuffix',
    defaultMessage: 'days',
    description: 'Suffix text after the events days input'
};

export const MODULE_EVENTS_DISPLAY_REQUIRED_ERROR_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.eventsDisplayRequiredError',
    defaultMessage: 'At least one of upcoming and past events must be displayed.',
    description: 'Error shown when both the upcoming and past events toggles are disabled'
};

export const MODULE_LAYOUT_FIELD_LABEL_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.layoutFieldLabel',
    defaultMessage: 'Layout',
    description: 'Label for the Layout dropdown of a module'
};

export const MODULE_LAYOUT_CAROUSEL_OPTION_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.layoutCarouselOption',
    defaultMessage: 'Carousel',
    description: 'Carousel option in the Layout dropdown'
};

export const MODULE_LAYOUT_LIST_OPTION_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.layoutListOption',
    defaultMessage: 'List View',
    description: 'List option in the Layout dropdown'
};

export const MODULE_DEFAULT_VIEW_FIELD_LABEL_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.defaultViewFieldLabel',
    defaultMessage: 'Default View',
    description: 'Label for the Default View dropdown of a module'
};

export const MODULE_DEFAULT_VIEW_COLLAPSED_OPTION_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.defaultViewCollapsedOption',
    defaultMessage: 'Collapsed',
    description: 'Collapsed option in the Default View dropdown'
};

export const MODULE_DEFAULT_VIEW_EXPANDED_OPTION_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.defaultViewExpandedOption',
    defaultMessage: 'Expanded',
    description: 'Expanded option in the Default View dropdown'
};

export const MODULE_ROW_DEACTIVATE_OPTION_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.deactivateOption',
    defaultMessage: 'Deactivate Module',
    description: 'Deactivate option in the module row context menu'
};

export const MODULE_ROW_ACTIVATE_OPTION_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.activateOption',
    defaultMessage: 'Activate Module',
    description: 'Activate option in the module row context menu (shown when module is inactive)'
};

export const MODULE_ROW_REMOVE_OPTION_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.removeOption',
    defaultMessage: 'Remove Module',
    description: 'Remove option in the module row context menu'
};

export const MODULE_ROW_LABEL_PREFIX_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.rowLabelPrefix',
    defaultMessage: 'Events:',
    description: 'Prefix shown on an Events module row before the user-defined label'
};

export const MODULE_ROW_SPEAKERS_LABEL_PREFIX_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.speakersRowLabelPrefix',
    defaultMessage: 'Speakers:',
    description: 'Prefix shown on a Speakers module row before the user-defined label'
};

export const NEW_SPEAKERS_MODULE_MODAL_TITLE_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.newSpeakersModalTitle',
    defaultMessage: 'New Module: Speakers',
    description: 'Title of the modal when creating a new Speakers module'
};

export const EDIT_SPEAKERS_MODULE_MODAL_TITLE_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.editSpeakersModalTitle',
    defaultMessage: 'Edit Module: Speakers',
    description: 'Title of the modal when editing an existing Speakers module'
};

export const MODULE_DISPLAYED_FIELDS_SECTION_LABEL_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.displayedFieldsSectionLabel',
    defaultMessage: 'Displayed Fields',
    description: 'Section header above the displayed-fields checkbox group in the Speakers modal'
};

export const RICH_TEXT_MODULE_TYPE_NAME_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.richTextTypeName',
    defaultMessage: 'Rich text',
    description: 'Name of the Rich Text module type in the type picker'
};

export const RICH_TEXT_MODULE_TYPE_DESCRIPTION_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.richTextTypeDescription',
    defaultMessage: 'A rich text area',
    description: 'Description of the Rich Text module type in the type picker'
};

export const MODULE_ROW_RICH_TEXT_LABEL_PREFIX_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.richTextRowLabelPrefix',
    defaultMessage: 'Rich Text:',
    description: 'Prefix shown on a Rich Text module row before the user-defined label'
};

export const NEW_RICH_TEXT_MODULE_MODAL_TITLE_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.newRichTextModalTitle',
    defaultMessage: 'New Module: Rich Text',
    description: 'Title of the modal when creating a new Rich Text module'
};

export const EDIT_RICH_TEXT_MODULE_MODAL_TITLE_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.editRichTextModalTitle',
    defaultMessage: 'Edit Module: Rich Text',
    description: 'Title of the modal when editing an existing Rich Text module'
};

export const MY_EVENTS_MODULE_TYPE_NAME_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.myEventsTypeName',
    defaultMessage: 'My Events',
    description: 'Name of the My Events module type in the type picker'
};

export const MY_EVENTS_MODULE_TYPE_DESCRIPTION_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.myEventsTypeDescription',
    defaultMessage: 'Displays events the attendee has registered for',
    description: 'Description of the My Events module type in the type picker'
};

export const MODULE_ROW_MY_EVENTS_LABEL_PREFIX_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.myEventsRowLabelPrefix',
    defaultMessage: 'My Events:',
    description: 'Prefix shown on a My Events module row before the user-defined label'
};

export const NEW_MY_EVENTS_MODULE_MODAL_TITLE_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.newMyEventsModalTitle',
    defaultMessage: 'New Module: My Events',
    description: 'Title of the modal when creating a new My Events module'
};

export const EDIT_MY_EVENTS_MODULE_MODAL_TITLE_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.editMyEventsModalTitle',
    defaultMessage: 'Edit Module: My Events',
    description: 'Title of the modal when editing an existing My Events module'
};

export const MODULE_CONTENT_FIELD_LABEL_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.contentFieldLabel',
    defaultMessage: 'Text',
    description: 'Label for the Text (content) field of the Rich Text module'
};

export const MODULE_DISPLAY_NAME_LABEL_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.displayNameLabel',
    defaultMessage: 'Name',
    description: 'Checkbox label for Name in the Speakers modal Displayed Fields section'
};

export const MODULE_DISPLAY_TITLE_LABEL_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.displayTitleLabel',
    defaultMessage: 'Title',
    description: 'Checkbox label for Title in the Speakers modal Displayed Fields section'
};

export const MODULE_DISPLAY_ORG_LABEL_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.displayOrgLabel',
    defaultMessage: 'Org',
    description: 'Checkbox label for Organization in the Speakers modal Displayed Fields section'
};

export const MODULE_DISPLAY_PROFILE_IMAGE_LABEL_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.displayProfileImageLabel',
    defaultMessage: 'Profile Image',
    description: 'Checkbox label for Profile Image in the Speakers modal Displayed Fields section'
};

export const MODULE_DISPLAY_BIO_LABEL_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.displayBioLabel',
    defaultMessage: 'Bio',
    description: 'Checkbox label for Bio in the Speakers modal Displayed Fields section'
};

export const SPEAKERS_SECTION_LABEL_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.speakersSectionLabel',
    defaultMessage: 'Speakers',
    description: 'Label for the Speakers section in the Speakers modal'
};

export const ADD_SPEAKERS_BUTTON_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.addSpeakersButton',
    defaultMessage: '{prefix}Add Speakers',
    description: 'Button label to open the speakers picker popover in the Speakers modal'
};

export const NEW_SPEAKER_BUTTON_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.newSpeakerButton',
    defaultMessage: '{prefix}New Speaker',
    description: 'Button label to open the Add Speaker form from the speakers picker popover'
};

export const NO_SPEAKERS_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.noSpeakers',
    defaultMessage: 'No speakers',
    description: 'Empty state text for the speakers picker popover when there are no speakers'
};

export const NO_MATCHING_SPEAKERS_SEARCH_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.noMatchingSpeakersSearch',
    defaultMessage: 'No speakers matching search criteria',
    description: 'Empty state text for the speakers picker popover when search has no matches'
};

export const ADD_SPEAKER_MODAL_TITLE_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.addSpeakerModalTitle',
    defaultMessage: 'Add Speaker',
    description: 'Title of the Add Speaker modal'
};

export const EDIT_SPEAKER_MODAL_TITLE_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.editSpeakerModalTitle',
    defaultMessage: 'Edit Speaker',
    description: 'Title of the Edit Speaker modal'
};

export const SPEAKER_FIRST_NAME_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.speakerFirstName',
    defaultMessage: 'First Name',
    description: 'Label for the First Name field in the Add Speaker modal'
};

export const SPEAKER_LAST_NAME_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.speakerLastName',
    defaultMessage: 'Last Name',
    description: 'Label for the Last Name field in the Add Speaker modal'
};

export const SPEAKER_TITLE_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.speakerTitle',
    defaultMessage: 'Title',
    description: 'Label for the Title field in the Add Speaker modal'
};

export const SPEAKER_ORGANIZATION_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.speakerOrganization',
    defaultMessage: 'Organization',
    description: 'Label for the Organization field in the Add Speaker modal'
};

export const SPEAKER_PROFILE_IMAGE_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.speakerProfileImage',
    defaultMessage: 'Profile Image',
    description: 'Label for the Profile Image field in the Add Speaker modal'
};

export const SPEAKER_BIO_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.speakerBio',
    defaultMessage: 'Bio',
    description: 'Label for the Bio field in the Add Speaker modal'
};

export const NO_ACCOUNT_ORGANIZATIONS_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.noAccountOrganizations',
    defaultMessage: 'No organizations',
    description: 'Empty state text for the Organization dropdown in the Add Speaker modal'
};

export const NO_MATCHING_ACCOUNT_ORGANIZATIONS_SEARCH_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.noMatchingAccountOrganizationsSearch',
    defaultMessage: 'No organizations matching search criteria',
    description: 'Empty state text for the Organization dropdown when search has no matches'
};

export const NEW_ORGANIZATION_BUTTON_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.newOrganizationButton',
    defaultMessage: '{prefix}New Organization',
    description: 'Button label to open the Add Organization form from the Organization dropdown'
};

export const ADD_ORGANIZATION_MODAL_TITLE_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.addOrganizationModalTitle',
    defaultMessage: 'Add Organization',
    description: 'Title of the Add Organization sub-window'
};

export const ORGANIZATION_NAME_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.modules.organizationName',
    defaultMessage: 'Organization Name',
    description: 'Label for the Name field in the Add Organization sub-window'
};

export const EDIT_CUSTOM_CSS_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.editCustomCss',
    defaultMessage: 'Edit Custom CSS',
    description: 'Button text to open the Edit Custom CSS popup on the Hub branding settings tab'
};

export const CUSTOM_CSS_APPLIED_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.customCssApplied',
    defaultMessage: 'Custom CSS has been applied',
    description: 'Indicator shown next to the Edit Custom CSS button when custom CSS has been applied'
};

export const CUSTOM_CSS_NOT_APPLIED_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.customCssNotApplied',
    defaultMessage: 'No Custom CSS has been applied',
    description: 'Indicator shown next to the Edit Custom CSS button when no custom CSS has been applied'
};

export const CUSTOM_CSS_LABEL_TEXT = {
    id: 'oe.eventHubs.websiteBuilder.customCssLabel',
    defaultMessage: 'Custom CSS',
    description: 'Label for the CSS code editor field in the Edit Custom CSS popup'
};
